export enum MapMode {
  HEAT_MAP = 'Heat Map',
  KEY_HOLE_RADIO_MAP = 'Key Hole Radio Map',
}
